import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';

const FixBottom = () => {
    const isCategoryPage = window.location.href.includes('/category');
    const search = location.search;
    const pidValue = isCategoryPage ? `https://news.ifeng.com/loc/lhqyjhd2026/category${search}` : 'https://news.ifeng.com/loc/lhqyjhd2026';
    const wxLaunchHackData = {
        callAppConfig: {
            docType: 'web',
            pid: pidValue,
            kind: 'lhqyhd2026',
            noKindFrom: 1,
        },
        statisticsConfig: {
            behavior: 'action',
            type: 'lhqyhd2026',
        },
    };

    return window.grounds ? null : (
        <div className={styles.fixedBottom}>
            <div className={styles.fixedBottomBox}>
                <img className={styles.fixedBottomPic1} src="https://x0.ifengimg.com/ucms/2021_31/31A0009714B77C212C710F60DBC83CB0AF8AAD57_size20_w750_h112.png" alt="" />
                <WxLaunchHack content={wxLaunchHackData} />
            </div>
            <img className={styles.fixedBottomPic2} src="https://x0.ifengimg.com/ucms/2021_31/31A0009714B77C212C710F60DBC83CB0AF8AAD57_size20_w750_h112.png" alt="" />
        </div>
    );
};

export default FixBottom;
